import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { Plus, X } from "lucide-react";
import { inr } from "@/lib/format";

const FIELDS = {
  cash: [],
  upi: [
    ["upi_ref", "UPI Reference / UTR"],
    ["pay_date", "Date", "date"],
  ],
  neft: [
    ["bank_details", "Bank / Account Details"],
    ["pay_date", "Transfer Date", "date"],
  ],
  cheque: [
    ["bank_name", "Bank Name"],
    ["cheque_number", "Cheque Number"],
    ["cheque_date", "Cheque Date", "date"],
  ],
  card: [
    ["card_details", "Card Details"],
    ["pay_date", "Date", "date"],
  ],
};

const blank = { mode: "cash", amount: "", bank_details: "", pay_date: "", bank_name: "", cheque_date: "", cheque_number: "", card_details: "", upi_ref: "" };

export default function PaymentMethods({ methods, setMethods, modes = ["cash", "upi", "neft", "cheque", "card"], testidPrefix = "pm" }) {
  const update = (i, patch) => setMethods(methods.map((m, idx) => (idx === i ? { ...m, ...patch } : m)));
  const add = () => setMethods([...methods, { ...blank, mode: modes[0] }]);
  const remove = (i) => setMethods(methods.filter((_, idx) => idx !== i));

  const total = methods.reduce((s, m) => s + Number(m.amount || 0), 0);

  return (
    <div className="space-y-3">
      {methods.map((m, i) => (
        <div key={i} className="rounded-lg border border-border p-3 bg-muted/30" data-testid={`${testidPrefix}-row-${i}`}>
          <div className="flex items-center gap-3">
            <div className="w-36">
              <Label className="text-xs">Mode</Label>
              <Select value={m.mode} onValueChange={(v) => update(i, { mode: v })}>
                <SelectTrigger className="mt-1 bg-card" data-testid={`${testidPrefix}-mode-${i}`}><SelectValue /></SelectTrigger>
                <SelectContent>
                  {modes.map((md) => <SelectItem key={md} value={md}>{md.toUpperCase()}</SelectItem>)}
                </SelectContent>
              </Select>
            </div>
            <div className="flex-1">
              <Label className="text-xs">Amount (₹)</Label>
              <Input type="number" value={m.amount} onChange={(e) => update(i, { amount: e.target.value })} className="mt-1 bg-card" data-testid={`${testidPrefix}-amount-${i}`} />
            </div>
            <Button type="button" size="icon" variant="ghost" className="text-destructive mt-5" onClick={() => remove(i)} data-testid={`${testidPrefix}-remove-${i}`}>
              <X className="h-4 w-4" />
            </Button>
          </div>
          {FIELDS[m.mode]?.length > 0 && (
            <div className="grid sm:grid-cols-3 gap-3 mt-3">
              {FIELDS[m.mode].map(([key, label, type]) => (
                <div key={key}>
                  <Label className="text-xs">{label}</Label>
                  <Input type={type || "text"} value={m[key] || ""} onChange={(e) => update(i, { [key]: e.target.value })} className="mt-1 bg-card" />
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
      <div className="flex items-center justify-between">
        <Button type="button" variant="outline" size="sm" onClick={add} data-testid={`${testidPrefix}-add`}>
          <Plus className="h-4 w-4" /> Add Payment
        </Button>
        <div className="text-sm">Paid: <span className="font-bold data-num">{inr(total)}</span></div>
      </div>
    </div>
  );
}
